<template>
    <div id="ChildProjects">
        <addChildProject
            v-bind:dialogAdd="dialogAdd"
            :pInfo="pInfo"
            :types="types"
            :systems="systems"
            @update="getData"
        ></addChildProject>
        <EditJikeng
            :dialogEdit="dialogEdit"
            :form="form"
            :pInfo="pInfo"
            :types="types"
            :systems="systems"
            @updateEdit="getData"
        ></EditJikeng>
        <menuSelect
            :dialogMenu="dialogMenu"
            :menu="menu"
            :chosed="chosed"
        ></menuSelect>
        <div class="data_head">
            <!-- value-key须保证唯一性,下拉框就不用进行去重处理了 -->
            <el-select clearable v-model="value1" value-key="id" @change="selectProject" >
                <el-option
                    v-for="item in projectInfo"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                ></el-option>
            </el-select>
            <el-button type="primary" @click="search()" class="searchButton">查&nbsp;询</el-button>
            <el-button type="primary" @click="handleAdd()" class="searchButton">添&nbsp;加</el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column align="center" prop="projectName" label="所属项目"></el-table-column>
                <el-table-column align="center" prop="name" label="结构名称"></el-table-column>
                <el-table-column align="center" prop="description" label="结构信息"></el-table-column>
                <el-table-column align="center" prop="coordinate" label="地理位置"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right" width="420">
                    <template slot-scope="scope">
                        <el-button size="mini" class="operateButton" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                        <!-- <el-button size="mini" class="operateButton" @click="jikengSwitch(scope.$index,scope.row)">结构切换</el-button> -->
                        <el-button size="mini" class="operateButton" @click="menuSelect(scope.row)">菜单选择</el-button>
                        <el-button size="mini" class="deleteButton"  @click="handleDelete(scope.row)">删&nbsp;除</el-button>
<!--                        <el-button size="mini" class="operateButton" v-if="scope.row.alarmApparatusId=='0'"  @click="bing(scope.row)">未有报警设备</el-button>-->
<!--                        <el-button size="mini" class="deleteButton" v-else @click="bing(scope.row)">已有报警设备</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              :current-page="page"
              :page-size="pageSize"
              layout="total,prev, pager, next, jumper"
              :total="total"
              class="pagination"
              background
            >
            </el-pagination>
          </div>
        </div>

        <!-- 切换结构提示框 -->
        <el-dialog title="提示" :visible.sync="dialogSwitch" width="400px" :modal-append-to-body='false'>
            确认切换至该结构？
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSwitch = false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body="false">
            <span>删除不可恢复，是否确定删除？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="del">确 定</el-button>
            </span>
        </el-dialog>
      <!--绑定提示框-->
      <el-dialog title="绑定报警设备" center :visible.sync="bangVisible" width="30%" :modal-append-to-body="false">
        <el-radio-group v-model="bangValue" size="small" class="alarmChoose">
          <el-radio class="alarmChooseItem"   v-for="(item,index) in dataList" :key="index" :label=item.id>{{item.alarmName}}</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
             <el-button @click="bangVisible = false">取 消</el-button>
             <el-button type="primary" @click="changeBing">确 定</el-button>
        </span>
      </el-dialog>

    </div>
</template>

<script>
import addChildProject from "./add-child-project-dialog";
import EditJikeng from "./EditJikeng";
import menuSelect from "./menu-select-dialog";

export default {
    name: "ChildProjects",
    components: {
        addChildProject,
        EditJikeng,
        menuSelect,
    },
    data() {
        return {
            data: [],
            list: [], // 用于存放数据
            projectInfo: [], // 项目下拉框数据
            total: null,
            page: 1, // 初始页
            pageSize: 10, // 每页显示的数据条数
            value1: "",
            dialogEdit: { show: false },
            dialogAdd: { show: false },
            dialogMenu: { show: false, childProjectId: 0 },
            form: {},
            pInfo: [], // 传值给dialog的项目数据
            types: [], // 传值给dialog的结构类型数据
            systems: [], // 传值给dialog的系统类型数据
            menu: [], // 菜单数据
            chosed: [],
            dialogSwitch: false,
            delDialogVisible: false,
            projectId: "",
            bangVisible:false,//绑定报警设备弹框
            // alarmText:'',//按钮内容
            dataList:[],//报警列表
            bangId:'',//需要绑定的测点Id
            bangValue:'',//绑定的alarm,value

        };
    },
    mounted: function () {
        this.getData();
        this.getdataList()
    },
    methods: {
        //如果当前菜单有数据，则不加载，如果没有就去加载，即菜单的懒加载
        loadMenu() {
            if (this.menu.length == 0) {
                this.$axios
                    .get("/api/monitor/project/child/getAllProjectMenu")
                    .then((res) => {
                        this.menu = res.data.datas.values;
                    });
            }
        },
        //获取列表信息
        getData() {
            const req = {};
            this.$axios
                .post("/api/monitor/project/child/childProjectInfo", req)
                .then((res) => {
                    if (res.data.status == 200) {
                        this.total = res.data.datas.values.childProjectList.length;
                        this.data = res.data.datas.values.childProjectList;
                        let projectName = res.data.datas.values.monitorProjectVoList[0].name;
                        this.list = this.data.filter(
                            (item, index) =>
                                index < this.page * this.pageSize &&
                                index >= this.pageSize * (this.page - 1)
                        );
                        this.list.forEach(item=>{
                            item.projectName=projectName
                        })
                        // 得到项目下拉框的值
                        this.projectInfo = res.data.datas.values.monitorProjectVoList;
                        /*等到时候绑定了设备状态*/
                    }
                    return;
                });
            // 得到类型与系统下拉框值
            this.$axios
                .post("/api/monitor/project/getValues", req)
                .then((res) => {
                    if (res.data.status == 200) {
                        this.jikengTypes = res.data.datas.values.typeData;
                        this.systemTypes = res.data.datas.values.systemData;
                    }
                    return;
                });
        },
        selectProject(event) {
            this.projectId = event.id;
        },
        search() {
            const req = {
                projectId: this.projectId,
            };
            this.$axios
                .post("/api/monitor/project/child/childProjectInfo", req)
                .then((res) => {
                    this.total = res.data.datas.values.childProjectList.length;
                    this.data = res.data.datas.values.childProjectList;
                    this.list = this.data.filter(
                        (item, index) =>
                            index < this.page * this.pageSize &&
                            index >= this.pageSize * (this.page - 1)
                    );
                });
        },
        handleCurrentChange(val) {
            this.page = val;
            const req = {
                page: this.page,
                pid: this.projectId,
            };
            this.$axios
                .post("/api/monitor/project/child/childProjectInfo", req)
                .then((res) => {
                    this.total = res.data.page.totalNumber;
                    this.list = res.data.page.content;
                });
        },
        handleAdd() {
            this.dialogAdd.show = true;
            this.pInfo = this.projectInfo;
            this.types = this.jikengTypes;
            this.systems = this.systemTypes;
        },
        handleEdit(index, row) {
            console.log(row)
            this.dialogEdit.show = true;
            this.pInfo = this.projectInfo;
            this.types = this.jikengTypes;
            this.systems = this.systemTypes;
            // 3D模型
            if (row.systemType==1) {
                this.form = {
                    id: row.id, // 结构编号
                    projectId: row.projectId, // 所属项目 数字
                    projectName: row.projectName, // 所属项目 汉字
                    type: row.type, // 结构类型 数字
                    typeName: row.type, // 结构类型 汉字
                    name: row.name, // 结构名称
                    coordinate: row.coordinate,
                    systemTypeName: row.systemTypeName, // 系统类型 汉字
                    systemType: row.systemType, // 系统类型 数字
                    // bimfaceModelId: row.childProjectType3d.bimfaceModelId, // 3D编号
                    description:row.description
                };
            }
            // 2D模型
            if (row.childProjectType2d) {
                this.form = {
                    id: row.id,
                    projectId: row.projectId,
                    projectName: row.projectName,
                    type: row.type,
                    typeName: row.type,
                    name: row.name,
                    coordinate: row.coordinate,
                    systemTypeName: row.systemTypeName,
                    systemType: row.systemType, //显示
                    projectPicPath: row.childProjectType2d.projectPicPath,
                    description:row.description
                };
            }
        },
        menuSelect(row) {
            this.dialogMenu.show = true;
            this.dialogMenu.childProjectId = row.id;
            this.loadMenu();
        },
        // TODO: 需要跟后端对接
        jikengSwitch(index, row) {
            window.localStorage.setItem("pitNo3", row.id);
            this.dialogSwitch = true;
        },
        // TODO: 接口待后端有时间对接
        save() {
            this.dialogSwitch = false;
            this.$router.push({
                path: "/RealTimeMonitor",
                name: "RealTimeMonitor",
                /*  query: {
             a:2
         }    */
            });
        },
        handleDelete(row) {
            this.delId = row.id;
            this.delDialogVisible = true;
        },
        del() {
            this.$axios.delete("/api/monitor/project/deleteChildProjectById", {params:{childProjectId: this.delId}}).then((res) => {
                if(res.data.status == 200){
                    this.$message.success("删除成功");
                    this.delDialogVisible = false;
                    this.getData();
                }
                return
            });
        },
        /*绑定*/
        /*获取设备数据列表*/
        getdataList(){
            this.$axios.get('/api/monitor/project/getAlarmApparatus').then(res=>{
                if (res.data.status == 200) {
                    this.dataList = res.data.datas.values;
                    this.dataList.unshift({alarmName:'默认(不绑定)',id:0})
                }
                return
            })
        },
        bing(info){
            this.bangId=info.id
            this.bangValue=info.alarmApparatusId
            this.bangVisible=true
        },
        changeBing(){
            // console.log(this.bangValue)
            this.$axios.put('/api/monitor/project/bindingAlarmApparatus?childProjectId='+this.bangId+'&'+'alarmApparatusId='+this.bangValue).then(res=>{
                if(res.data.status==200){
                    this.getData();
                    this.bangVisible=false
                    this.$message({message:'绑定成功',type:'success'})
                }else {this.$message({message:res.data.message,type:'error'})}
            })
        }
    },
};
</script>

<style>
  /*!* 选中后的字体颜色 *!*/
  .el-radio__input.is-checked + .el-radio__label {
    color: #3457DE !important;
  }
  /* 选中后小圆点的颜色 */
  .el-radio__input.is-checked .el-radio__inner {
    background: #3457DE !important;
    border-color: #3457DE !important;
  }


  /*  #ChildProjects .el-table{*/
  /*      color: #A7CCF6;*/
  /*  }*/

  /*  #ChildProjects .el-table__row {*/
  /*      background-color: #0B3A68 !important;*/
  /*  }*/

  /*  #ChildProjects .el-table--striped .el-table__body tr.el-table__row--striped td{*/
  /*      background-color: #021535;*/
  /*  }*/

  /*  #ChildProjects .el-table td{*/
  /*      border: unset;*/
  /*  }*/

  /*  #ChildProjects .el-table th.is-leaf{*/
  /*      border-bottom: none;*/
  /*  }*/


  #ChildProjects .el-select .el-input__inner{
    background-color: #3457DE;
    color: #FFF;  /* 选择后显示的颜色 */
  }
  #ChildProjects .el-cascader .el-input  .el-input__inner{
    color: #FFF;
    background-color: #3457DE;
  }
  #ChildProjects .el-select-dropdown__list{
    background-color: white;
  }

  #ChildProjects .el-date-editor .el-input__inner{
    background-color: #3457DE;
    color: #FFF;
  }

  #ChildProjects .el-table{
    color: #A7CCF6;
  }

  #ChildProjects .el-table__row {
    background-color: #0B3A68 !important;
  }

  #ChildProjects .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: #021535;
  }

  #ChildProjects .el-table td{
    border: unset;
  }

  #ChildProjects .el-table th.is-leaf{
    border-bottom: none;
  }
</style>

<style scoped>
    @import url('../../assets/css/style.css');
    .operateButton{
        background: #E68F02;
        border-color: #E68F02;
        color: #FFF;
    }
    .deleteButton{
        background: #FB4D4B;
        border-color: #FB4D4B;
        color: #FFF;
    }
    .pagination {
        margin-top: 30px;
        text-align: center;
    }
  .alarmChoose{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  .alarmChooseItem{
    margin: 5px 10px;
  }
    #ChildProjects  /deep/  .el-select-dropdown__list{
      /*background-color:transparent;*/
      background-color: #fff;
    }
</style>




// WEBPACK FOOTER //
// src/components/project/childprojects.vue